import React from 'react';

export default ({children})=> (
	<div className='FormContainer'>
		{children}
	</div>
);